// extracted by mini-css-extract-plugin
module.exports = {"svgDiv":"TaskCheckbox_svgDiv__1UHFv","svg":"TaskCheckbox_svg__2KLGM","svgChecked":"TaskCheckbox_svgChecked__2DtdF","svgUnchecked":"TaskCheckbox_svgUnchecked__1ZFTS"};